import { links } from "@/constants/links";
import { http } from "../httpHandler";
import { TServerErrorResponse } from "@/types";
import { ParagonConfig } from "@/types/paragon-config";

export const GET_PARAGON_CONFIG = "get-paragon-config";

export const getParagonConfigs = async (): Promise<
  ParagonConfig[] | undefined
> => {
  try {
    const response = await http.get<ParagonConfig[]>(links.paragonConfig.index);

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
